import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

import type { Currency } from 'src/app/models/currency';
import { WithdrawalFeeCrypto } from 'src/app/models/exchange-fees';

@Component({template: ''})
export class SearchComponent<T extends {}> implements OnInit, OnChanges {
  @Input() items: T[] = [];
  @Input() searchValue: string;
  @Input() filteredFields: (keyof T)[];
  @Input() light = false;

  @Output() getFilteredData = new EventEmitter<{ filteredItems: T[], searchValue: string }>();

  searchControl = new FormControl(null);

  constructor() {}

  ngOnInit() {
    this.handleSearch();
  }

  ngOnChanges(changes: SimpleChanges) {
    // clear from outside
    if (changes.searchValue?.previousValue && !changes?.searchValue?.currentValue) {
      this.searchControl.setValue('');
    }
  }

  handleSearch() {
    this.searchControl.valueChanges.subscribe(val => {
      if (val) {
        this.filterData(val.trim().toLowerCase());
      } else {
        this.filterData('');
      }
    });
  }

  isIncluded(value: unknown, substr: string) {
    return (value as string)?.toLowerCase()?.indexOf(substr) >= 0;
  }

  filterData(searchValue = null) {
    const filteredItems = !searchValue ? this.items : this.items.filter(item => {
      return this.filteredFields.reduce((prev, curr) => prev || this.isIncluded(item[curr], searchValue), false);
    });
    this.getFilteredData.emit({ filteredItems, searchValue });
  }
}

@Component({
  selector: 'search-crypto-component',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchCryptoComponent extends SearchComponent<Currency> {}

@Component({
  selector: 'search-crypto-fee-component',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchCryptoFeeComponent extends SearchComponent<WithdrawalFeeCrypto> {}
